module.exports = __webpack_public_path__ + "img/26.b01130eb.jpg";